import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { RestaurantDetails } from '../../restaurants/models/List.Restaurant';
import { RestaurantService } from '../../restaurants/services/Restaurant.service';
import { announcementType, ListData, ListFilter } from '../models/List.GuestAnnouncement';
import { AnnouncementService } from '../services/Announcements.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-guest-announcements',
  templateUrl: './guest-announcements.component.html'
})
export class GuestAnnouncementsComponent implements OnInit {
  dataLoading = true;
  showFilter = false;
  showSearch = false;
  pageIndex = 0;
  pageCount = 0;
  pageSize = 10;
  typeValue!: any;

  filterFormGroup: FormGroup = new FormGroup({});
  filterModel: ListFilter = new ListFilter();
  today = new Date();

  // Restaurant ID
  restaurantId?: any;
  allRestaurants: RestaurantDetails[] = [];
  restaurantData!: any;

  typesListAll = [
    { name: this.translate.instant('content4.Upcoming & Ongoing'), id: announcementType.UpcomingAndOngoing },
    { name: this.translate.instant("content4.Past"), id: announcementType.Past }
  ];

  recordsData!: ListData | null;

  subscriptions: Subscription[] = []


  constructor(private translate: TranslateService,
    private restaurantService: RestaurantService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private service: AnnouncementService,
    private route: ActivatedRoute,
    private router: Router) { }

  ngOnInit(): void {
    this.filterModel.pageSize = this.pageSize;
    this.filterModel.announcementStuts = announcementType.UpcomingAndOngoing;
    // this.getAll(null)
    this.buildFilterForm()
    this.subscriptions.push(
      this.service.refreshList.subscribe(data => {
        if (data) {
          this.getAll(null);
        }
      })
    )
  }

  GetRestaurantShortDetails(restaurantId: any) {
    this.restaurantService.GetRestaurantShortDetails(restaurantId).subscribe((data: any) => {
      this.restaurantData = data
    })
  }

  ngOnDestroy() {
    this.service.refreshList.next(false);
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  buildFilterForm() {
    this.filterFormGroup = this.formBuilder.group({
      dateFrom: [null],
      dateTo: [null],
      timeTo: [null],
      timeFrom: [null],
      companionsNumber: [null]
    });
  }

  getAll(event: any, restId?: any) {
    this.dataLoading = true;
    this.restaurantId = restId;
    if (!event) {
      this.pageIndex = 0;
    }
    if (event && event.pageSize) {
      this.pageIndex = event.pageIndex;
      this.filterModel.pageSize = event.pageSize;
    }
    this.filterModel.pageNumber = this.pageIndex;
    this.filterModel.restaurantID = this.restaurantId
    this.service.getAll(this.filterModel).subscribe(
      (data: ListData) => {
        this.dataLoading = false;
        if (data) {
          this.recordsData = data;
          this.pageCount = Math.ceil(this.recordsData.totalCount / this.filterModel.pageSize);
        }
      },
      (error: any) => {
        this.recordsData = null;
        this.dataLoading = false;
      });


  }

  typeFilter(selected: any) {
    const selectedType = this.typesListAll.find(element => element.id === selected.value);
    if (selectedType) {
      this.typeValue = selectedType;
    }
    this.makeFilter();
  }

  makeFilter() {
    const controls = this.filterFormGroup.controls;
    this.filterModel.dateFrom = controls['dateFrom'].value;
    this.filterModel.dateTo = controls['dateTo'].value;
    this.filterModel.timeTo = controls['timeTo'].value;
    this.filterModel.timeFrom = controls['timeFrom'].value;
    this.filterModel.companionsNumber = controls['companionsNumber'].value;

    if (controls['timeTo'].value) {
      this.filterModel.dateTo = controls['timeTo'].value;
    }
    if (controls['timeFrom'].value) {
      this.filterModel.dateTo = controls['timeFrom'].value;
    }
    this.getAll(null, this.restaurantId);
  }
  clearFilter() {
    this.filterModel = new ListFilter();
    this.filterModel.pageSize = this.pageSize
    this.getAll(null, this.restaurantId);
    this.filterModel.announcementStuts = announcementType.UpcomingAndOngoing;
    this.filterFormGroup.reset();
  }

  makeSearch() {
    if (!this.showSearch) {
      this.showSearch = true; // Show input
    } else {
      if (this.filterModel.searchText) {
        this.getAll(null, this.restaurantId);
      }
    }
  }

  resetSearch() {
    this.filterModel.searchText = '';
    this.getAll(null, this.restaurantId);
  }

  ////////////////////////////////////////////

  deleteRecord(recordId: string) {
    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousuretodelete'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yesdeleteit'),
      cancelButtonText: this.translate.instant('swalMsg.Nokeepit')
    }).then((result) => {
      if (result.value) {
        this.dataLoading = true;
        // this.service.delete(recordId).subscribe(
        //   (data: any) => {
        //     if (data) {
        //       Swal.fire({
        //         title: this.translate.instant('swalMsg.Success'),
        //         text: this.translate.instant('swalMsg.deletededsuccessfuly'),
        //         icon: 'success',
        //         confirmButtonText: this.translate.instant('swalMsg.Ok')
        //       });
        //       this.getAll(null);
        //     }
        //   },
        //   (error: any) => {
        //     this.dataLoading = false;
        //     Swal.fire({
        //       title: this.translate.instant('swalMsg.Failed'),
        //       text: error.detail,
        //       icon: 'error',
        //       confirmButtonText: this.translate.instant('swalMsg.Ok'),
        //     });
        //   });
      }
    });
  }
  

  GetScreenData() {
    this.recordsData = null;
    this.getAll(null, this.restaurantId);
    this.GetRestaurantShortDetails(this.restaurantId);
  }
}
